/*
 * This takes a class and retrieves those class members from the PHP server,
 * sends grads back to Parent Component where the data will be parsed.
 * 
 * Called by <ShowGradsFromOneClass />
 */
import React, { useEffect }                     from 'react'
import axios                                    from 'axios'
import { node_server }                          from '../Helpers'
import PropTypes                                from 'prop-types'

const GradsForOneClass = ({getGradsForOneClass, tpsClass}) => {


   /* Calls the PHP server and gets all alumni members of the selected class,
   gets parsed into first and last name below */
   useEffect(() => {
   axios.get(node_server + `grad/getGradsForOneClass/${tpsClass}`)
      .then(res => res.data)
      .then(data => {
         getGradsForOneClass(data.allGrads)
      })
   }, [ tpsClass ])

   return (
      <div>
      
      </div>
   )
}

GradsForOneClass.propTypes = {
  getGradsForOneClass: PropTypes.func,
  tpsClass: PropTypes.string
}

export default GradsForOneClass
